import React from 'react';
import {View, Image, I18nManager, Platform} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";
import RNRestart from 'react-native-restart';
import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import AsyncStorage from "@react-native-async-storage/async-storage";
import HttpRequest from "../utils/HttpRequest";
import IUser from "../Models/User/IUser";
import {EUserType} from "../Models/User/EUserType";
import {saveUser} from "../Models/User/UserActions";


type navProps = StackNavigationProp< any, 'Splash'>;
interface IProps {
    navigation:navProps;
    saveUser:(user:IUser)=>AnyAction

}
interface IState {

}

class Splash extends React.Component<IProps> {

    state:IState={

    }
    async componentDidMount() {
        I18nManager.allowRTL(true)
        I18nManager.forceRTL(true)

        // On web, set document direction instead of restarting the native process.
        if (Platform.OS === 'web') {
            if (typeof document !== 'undefined') {
                document.documentElement.dir = 'rtl';
                document.documentElement.lang = 'he';
            }
        } else if (I18nManager.isRTL === false) {
            RNRestart.restart();
            return
        }

        let userJson=await AsyncStorage.getItem('user')
        if(userJson==null || userJson==''){
            setTimeout(()=>this.props.navigation.navigate('Login'),1500);
            return;
        }
        let user:IUser=JSON.parse(userJson);
        this.login(user)
    }
    login(user:IUser){

        this.setState({isLoading:true})
        HttpRequest('users/login',"POST",{userName:user.userName,password:user.password}).then( async (result)=>{
            if(result.status==200){
                let user:IUser=result.data.user;
                let token=result.data.token;
                await AsyncStorage.setItem('token',token)
                this.props.saveUser(user);
                if(user.type==EUserType.admin){
                    this.props.navigation.navigate('Clients')
                    return;
                }
                this.props.navigation.navigate('OrderHistory')
                return;
            }
            this.props.navigation.navigate('Login')

        }).catch(e=>{

            this.props.navigation.navigate('Login')
        }).finally(()=>this.setState({isLoading:false}))
    }
    render() {
        return(
            <View style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:30,backgroundColor:'white',flex:1,width:'100%'}}>
                <Image source={require('../assets/splashImg.png')} resizeMode={'cover'} style={{width:'100%',height:'100%'}}/>

            </View>
        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {

    };
};

const mapDispatchToProps ={
    saveUser:saveUser


};

export default connect(mapStateToProps, mapDispatchToProps)(Splash);
